import LoginForm from "../features/accounts/components/LoginForm";

const loginGridStyle = {
    backgroundImage:
        `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.18)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>')`,
};

function LoginImage() {
    return (
        <div className="relative flex min-h-48 shrink-0 items-center justify-center overflow-hidden bg-accent px-page-x py-8 bp-lg:min-h-screen bp-lg:flex-1 bp-lg:p-0">
            <div
                aria-hidden
                className="pointer-events-none absolute inset-0 opacity-40"
                style={loginGridStyle}
            />
            <div className="relative z-[1] text-center text-text-inverse">
                <span className="material-symbols-outlined mb-3 text-[3rem] leading-none opacity-90 bp-lg:mb-4 bp-lg:text-[4rem]">
                    archive
                </span>
                {/* Exception: brand hero — intentional light weight, not pageShell.title */}
                <h3 className="mb-2 text-2xl font-light tracking-[0.1em] bp-lg:text-3xl">
                    TERRALOGUE
                </h3>
                <p className="text-base font-light opacity-80 bp-lg:text-lg">
                    AIデジタルアーカイブ
                </p>
            </div>
        </div>
    );
}

function LoginPage() {
    return (
        <main className="fixed inset-0 flex items-center justify-center overflow-hidden bg-bg-primary">
            <div className="flex h-full w-full flex-col overflow-hidden bg-surface bp-lg:flex-row">
                <LoginImage />
                <div className="flex flex-1 items-center justify-center p-4 bp-lg:p-0">
                    <LoginForm />
                </div>
            </div>
        </main>
    );
}

export default LoginPage;
